// extracted by mini-css-extract-plugin
export default {"footer":"footer___h2Xen","socialIcons":"social-icons___ID47y"};